export const findGlobalSetting = (settings, identifier) => {
  const setting = settings.find(setting => setting.ident === identifier);
  return parseInt(setting.value);
};
